<template>
  <div>
    <a-descriptions bordered size="small" title="" :column="model.length < 6 ? (model.length < 3 ? 3 : model.length) : 6">
      <a-descriptions-item :label="item.name" v-for="item in model">{{ item.vaules }}</a-descriptions-item>
    </a-descriptions>
  </div>
</template>

<script>
export default {
  props: ['model'],
  watch: {
    model: {
      handler (model) {
        if (model) {
          this.initData()
        }
      },
      deep: true,
      immediate: true
    }
  },
  data () {
    return {
      detail: {
        xxx: ''
      }
    }
  },
  methods: {
    initData () {
    }
  }
}
</script>

<style scoped>

</style>
